import styled from 'styled-components';

const IconButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'noBg' && prop !== 'round',
})`
  background-color: ${({ noBg, theme }) => (noBg ? 'none' : theme.colors.brandBackground || 'rgba(130, 22, 146, 0.1)')};
  color: ${({ theme }) => theme.colors.brand || 'rgba(130, 22, 146, 1)'};
  border: none;
  border-radius: ${({ round }) => (round ? '50%' : '8px')};
  width: ${({ round }) => (round ? '40px' : 'auto')};
  height: ${({ round }) => (round ? '40px' : 'auto')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: ${({ noBg }) => (noBg ? '0' : '0.625rem 0.9375rem')};
  font-size: ${({ noBg, theme }) => (noBg ? '1.2rem' : theme.fontSizes.medium || '1rem')};
  font-weight: ${({ noBg }) => (noBg ? 'normal' : 'bold')};
  gap: 0.3125rem;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: ${({ noBg, theme }) => (noBg ? 'none' : theme.colors.brandLighter || 'rgba(130, 22, 146, 0.2)')};
    color: ${({ noBg, theme }) => (noBg ? theme.colors.brandLight || 'rgba(130, 22, 146, 0.8)' : 'inherit')};
    transform: ${({ noBg }) => (noBg ? 'scale(1.1)' : 'none')};
  }

  .icon, .info-icon {
    font-size: 1.5rem;
  }
`;

export default IconButton;
